import { FC } from 'react';

import { useTranslation } from 'react-i18next';
import { getDateFromNow, getFormattedDate } from '@/helpers';
import styles from './AmlCheckGeneralInfo.module.sass';

interface AmlCheckGeneralInfoProps {
  data: Record<string, any> | null;
  owner?: string;
}

const AmlCheckGeneralInfo: FC<AmlCheckGeneralInfoProps> = ({ data, owner }) => {
  const { t } = useTranslation();
  const firstChange = data?.first_tx ? getFormattedDate(data.first_tx) : '';
  const lastChange = data?.last_tx ? getFormattedDate(data.last_tx) : '';
  const countTransactions = data?.n_txs || '';

  return (
    <div className={styles.general}>
      <div className={styles.general__title}>
        {t('translation.sideblock_general_info_title')}
      </div>

      <div className={styles.general__list}>
        {!!owner && (
          <dl>
            <dt>{t('translation.owner_str')}:</dt>
            <dd>{owner}</dd>
          </dl>
        )}

        {!!firstChange && (
          <dl>
            <dt>{t('translation.balance_first_change')}:</dt>
            <dd>{firstChange}</dd>
          </dl>
        )}

        {!!lastChange && (
          <dl>
            <dt>{t('translation.balance_latest_change')}:</dt>
            <dd>{lastChange}</dd>
          </dl>
        )}

        {!!countTransactions && (
          <dl>
            <dt>{t('translation.account_transactions_count')}:</dt>
            <dd>{countTransactions}</dd>
          </dl>
        )}
      </div>
    </div>
  );
};

export default AmlCheckGeneralInfo;
